import React from 'react'
import "./CommonHeader.css"
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux';
function CommonHeader({title}) {
          const { currentLocal } = useSelector((state) => state.currentLocal);

  return (
    <div className='d-flex justify-content-center flex-column align-items-center common_header_container mb-5'>
      <p className='fw-bold'>{title}</p>
      <div className='mt-3 d-flex align-items-center'>
        <Link to="/"className='text-black  mx-1'>{currentLocal.home.home}</Link>
        / 
        <p className='mb-0 mx-1'>{title}</p>
      </div>
    </div>
  )
}

export default CommonHeader